// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aboutUsContainer {
  background-color: #172639;
  color: white;
  padding: 90px 60px;
}

.aboutHeading {
  color: #f2d38c;
  font-weight: 800;
  font-size: 2.75rem;
  margin-bottom: 24px;
}

.aboutText {
  color: rgba(255, 255, 255, 0.88);
  font-size: 1.05rem;
  line-height: 1.8;
  margin-bottom: 0;
}

.aboutImage {
  aspect-ratio: 597 / 598;
  object-fit: cover;
}

@media (max-width: 992px) {
  .aboutUsContainer {
    padding: 60px 30px;
  }

  .aboutHeading {
    font-size: 2.1rem;
  }
}

@media (max-width: 768px) {
  .aboutUsContainer {
    padding: 45px 20px;
    text-align: center;
  }

  .aboutHeading {
    font-size: 1.8rem;
  }

  .aboutText {
    font-size: 0.95rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AboutUs.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".aboutUsContainer {\n  background-color: #172639;\n  color: white;\n  padding: 90px 60px;\n}\n\n.aboutHeading {\n  color: #f2d38c;\n  font-weight: 800;\n  font-size: 2.75rem;\n  margin-bottom: 24px;\n}\n\n.aboutText {\n  color: rgba(255, 255, 255, 0.88);\n  font-size: 1.05rem;\n  line-height: 1.8;\n  margin-bottom: 0;\n}\n\n.aboutImage {\n  aspect-ratio: 597 / 598;\n  object-fit: cover;\n}\n\n@media (max-width: 992px) {\n  .aboutUsContainer {\n    padding: 60px 30px;\n  }\n\n  .aboutHeading {\n    font-size: 2.1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .aboutUsContainer {\n    padding: 45px 20px;\n    text-align: center;\n  }\n\n  .aboutHeading {\n    font-size: 1.8rem;\n  }\n\n  .aboutText {\n    font-size: 0.95rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
